/**
 * Emit hosts for the `scribe` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type Brain } from '@heidi/schema/ml-scribe';

export function trackScribeStyleUpdated(input: {
  sessionId: string;
  brain: Brain;
  oldBrain?: Brain;
  tabType: 'note' | 'document';
  isRegenerate?: boolean;
}) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ScribeStyleUpdated,
    props: {
      session_id: input.sessionId,
      brain: input.brain,
      old_brain: input.oldBrain,
      tab_type: input.tabType,
      is_regenerate: input.isRegenerate,
    },
  });
}
